import { useAuth0 } from '@auth0/auth0-react'

import React from 'react'
import { useLocation } from 'react-router-dom'

import {
  markVerifyEmailDismissed,
  shouldShowSignupVerifyPrompt,
  useCanPerformVerifiedAction,
} from '../utils/emailVerification'
import { AuthPromptModal } from './AuthPromptModal'

/**
 * One-screen post-signup email verification prompt.
 * Write-action gates on individual pages handle users who tap Later.
 */
export const EmailVerificationPrompt: React.FC = () => {
  const { isAuthenticated, user } = useAuth0()
  const location = useLocation()
  // Re-render when verification state changes (dismiss / I've verified).
  useCanPerformVerifiedAction()

  if (!isAuthenticated || !user?.sub || !shouldShowSignupVerifyPrompt(isAuthenticated, user)) {
    return null
  }

  const handleDismiss = () => {
    markVerifyEmailDismissed(user.sub!)
  }

  return <AuthPromptModal returnTo={location.pathname} mode="verify-email" variant="signup" onDismiss={handleDismiss} />
}
